import { WEBSITE_ID_UNKNOWN } from './constants';

const extractWebsiteIdFromLoginUrl = (loginUrl: string): string => {
  const obfuscatedWebsiteId = loginUrl.match(/(?:\/s\/|\?websiteId=)(s[\d\w]{7,})\/?/);
  return obfuscatedWebsiteId ? obfuscatedWebsiteId[1] : WEBSITE_ID_UNKNOWN;
};

export default extractWebsiteIdFromLoginUrl;
